// extracted by mini-css-extract-plugin
export default {"root":"InputPrice_root__v21Ut","error":"InputPrice_error__Ye3FS","inner":"InputPrice_inner__M6uxv","promptWrap":"InputPrice_promptWrap__vp4PC","label":"InputPrice_label__94ebJ"};